import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import ContentContainer from "../atoms/ContentContainer";
import Title from "../atoms/Title";
import Paragraph from "../atoms/Paragraph";
import CleanInputItem from "../atoms/CleanInputItem";
import InputCheckbox from "../atoms/InputCheckbox";
import IdealButton from "./IdealButton";
import axios, { errorsTransformer } from "../../Http";
import * as Endpoint from "../../Http";
import { bugsnagClient } from "../../services/bugsnag";
import ErrorNotice from "../atoms/ErrorNotice";
import { useTranslation } from "react-i18next";
import FrameFooter from "../atoms/FrameFooter";
import LanguageSelection from "../atoms/LanguageSelect";
import LanguageToggle from "./LanguageToggle";
import LanguageSelector from "./LanguageSelector";
import Flex from "../invoned/atoms/generic/Flex";
import File from "../invoned/atoms/icons/File";
import Euro from "../invoned/atoms/icons/Euro";
import { getAppThemeName, getLogoForTheme } from "../../../services/appTheme";
import Button from "../atoms/Button";
import InvonedInputItem from "../atoms/InvonedInputItem";
const StyledPaymentFrame = styled.div `
  position: relative;
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  transition: all 300ms cubic-bezier(0.2,0,0,1) 0s;
  left: ${props => props.expanded ? "-350px" : "0"};

  @media only screen and (min-width: 768px) {
    left: ${props => props.expanded ? "-430px" : "0"};
    width: 450px;
    max-width: none;
    margin: 0 auto;
  }

  @media only screen and (min-width: 992px) {
    width: 526px;
    left: ${props => props.expanded ? "-230px" : "0"};
  }
`;
const PaymentHeader = styled(Title) `
  font-size: 24px;
  font-family: ${props => props.theme.fontHead};
  font-weight: 700;
  margin-bottom: 10px;

  @media only screen and (min-width: 992px) {
    font-size: 30px;
  }
`;
const ContentWrapper = styled.div `
  margin-bottom: 30px;
`;
const StyledParagraph = styled(Paragraph) `
  margin-bottom: 20px;
  font-size: 15px;
  color: ${props => props.theme.textLight};

  @media only screen and (min-width: 992px) {
    font-size: 20px;
    margin-bottom: 45px;
  }
`;
const StyledContentContainer = styled(ContentContainer) `
  box-shadow: ${props => props.theme.name === "invoned" ? "0px 0px 10px rgba(26, 26, 26, 0.11)" : "0 0 30px rgba(0, 0, 0, 0.1)"};
  padding: 20px;
  border-radius: 12px;
  
  @media only screen and (min-width: 992px) {
      padding: 35px;
  }

  ${props => props.theme.name === "invoned" && css `
    max-width: 475px;
    padding: 25px;
    border-radius: 5px;
    
    @media only screen and (min-width: 992px) {
      padding: 30px 45px;
    }
  `}
`;
const StyledFlex = styled(Flex) `
  flex-direction: column;
  gap: 1rem;
  
  @media only screen and (min-width: 768px) {
    flex-direction: row;
    margin-top: 15px;
  }
  
  @media only screen and (min-width: 992px) {
    position: relative;
  }
`;
const StyledLink = styled.a `
  position: relative;
  display: inline-block;
  color: ${props => props.theme.tertiary};
  font-family: ${props => props.theme.fontBase};
  margin-top: ${props => props.noMargin ? "0" : "20px"};
  font-size: 15px;
  text-decoration: none;

  @media only screen and (min-width: 768px) {
    font-size: 17px;
  }

  &:before {
    content: "";
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: ${props => props.theme.tertiary};
  }
  
  ${props => props.color === "orange" && css `
    color: ${props => props.theme.primary};
    
    &:before {
      background-color: ${props => props.theme.primary};
    }
  `};
`;
const StyledInputCheckbox = styled(InputCheckbox) `
  label {
    display: flex;
    line-height: 22px;

    &:after {
      top: 7px;
    }
  }
`;
const LinkContainer = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
`;
const StyledErrorNotice = styled(ErrorNotice) `
  margin-bottom: 15px;
`;
const StyledErrorLink = styled.a `
  text-decoration: underline;
  color: white;
  cursor: pointer;
`;
const StyledCleanInputItem = styled(CleanInputItem) `
  @media only screen and (min-width: 768px) {
      max-width: 195px;
  }

  ${props => props.readOnly && css `
    input {
      opacity: .5;
      
      &:focus {
        border: 1px solid #D6DAE0
      }
      
      ~ div svg {
        opacity: .5;
      }
    }
  `};
`;
const StyledFrameFooter = styled(FrameFooter) `
  margin-top: 10px;
  justify-content: ${props => props.appTheme === "invoned" ? "center" : "space-between"};
  align-items: center;
  
  @media only screen and (min-width: 768px) {
    justify-content: center;
  }
`;
const StyledInvonedLogo = styled.img `
  margin: 0 auto 30px auto;
  width: 220px;
`;
const getFormattedAmount = (amountInCents) => {
    return amountInCents ? (amountInCents / 100).toFixed(2) : ""; //.replace(",", ",") : "";
};
const getPaymentUrl = (payload) => {
    return axios.post(Endpoint.FETCH_OPEN_PAYMENT_REDIRECT_URL, payload);
};
const PaymentFrame = ({ amountInCents, dossierNumber, debtorPortal, simpleMode, appTheme }) => {
    const { t } = useTranslation(["common", "payment_portal"]);
    const [editable, setEditable] = useState(amountInCents === null);
    const [dossier, setDossier] = useState(dossierNumber);
    const [amount, setAmount] = useState(getFormattedAmount(amountInCents));
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [isExpanded, setExpanded] = useState(false);
    const [open, setOpen] = useState(false);
    const getContactLink = (appTheme) => {
        if (appTheme === "inkassier") {
            return (React.createElement(LinkContainer, null,
                React.createElement(StyledLink, { href: "https://www.inkassier.nl/contact" }, t("payment_portal:generic.contact_us"))));
        }
    };
    const getDossierLink = (appTheme) => {
        if (appTheme === "inkassier") {
            return (React.createElement(Flex, { justifyContent: "center" },
                React.createElement(LinkContainer, null,
                    React.createElement(StyledLink, { noMargin: true, href: debtorPortal + "/login" + (dossierNumber || dossier ? "?dossier=" + (dossierNumber || dossier) : "") }, t("payment_portal:generic.view_dossier")))));
        }
    };
    const submit = (e) => {
        e.preventDefault();
        if (e.currentTarget && e.currentTarget.reportValidity && !e.currentTarget.reportValidity()) {
            return;
        }
        setErrors({});
        setLoading(true);
        getPaymentUrl({
            dossier: dossier,
            amount: amount.replace(",", ".")
        })
            .then(response => {
            if (response.data.redirect_uri) {
                localStorage.setItem("payment_portal.payment_id", response.data.payment_id);
                if (localStorage.getItem("payment_portal.payment_id")) {
                    window.location.href = response.data.redirect_uri;
                    return;
                }
                setLoading(false);
                bugsnagClient.notify("Payment ID not stored in localStorage");
            }
            else {
                setLoading(false);
                bugsnagClient.notify("Redirect uri not received");
            }
        })
            .catch(err => {
            err = errorsTransformer(err);
            setLoading(false);
            setErrors(err.errors);
        });
    };
    const buttonDisabled = simpleMode ? (!amount || !dossier || loading) : (!amount || !dossier || loading);
    useEffect(() => {
    }, []);
    const isInvoned = appTheme === 'invoned';
    const Input = isInvoned ? InvonedInputItem : CleanInputItem;
    return (React.createElement(StyledPaymentFrame, { expanded: open },
        React.createElement(StyledContentContainer, { largeGutter: true, hasShadow: true },
            React.createElement("form", { autoComplete: "off", onSubmit: e => submit(e), "data-testid": "payment-form" },
                isInvoned ? React.createElement(Flex, null,
                    React.createElement(StyledInvonedLogo, { src: getLogoForTheme() })) : React.createElement(PaymentHeader, { tag: "h1" }, t("app_name")),
                React.createElement(ContentWrapper, null,
                    !isInvoned && React.createElement(StyledParagraph, null, simpleMode ? t("payment_portal:payment.introduction_simple") : t("payment_portal:payment.introduction")),
                    errors.generic_error && (React.createElement(StyledErrorNotice, null, errors.generic_error)),
                    React.createElement(CleanInputItem, { autoComplete: "off", label: t("payment_portal:payment.dossier"), name: "dossier", value: dossier || "", onChange: e => setDossier(e.currentTarget.value), type: "text", disabled: loading, error: errors.dossier, required: true, icon: React.createElement(File, null) }),
                    React.createElement(StyledFlex, { justifyContent: "space-between" },
                        React.createElement(StyledCleanInputItem, { autoComplete: "off", label: t("payment_portal:payment.amount"), name: "amount", onChange: (e) => { setAmount(e.currentTarget.value); }, type: "number", formatCents: true, value: amount || "", readOnly: !editable, disabled: loading, error: errors.amount, required: true, icon: React.createElement(Euro, null) })),
                    amountInCents !== null && (React.createElement(StyledInputCheckbox, { label: t("payment_portal:payment.other_amount"), id: "custom_amount_checkbox", checked: editable, onChange: (e) => {
                            setEditable(e.currentTarget.checked);
                            if (!e.currentTarget.checked) {
                                setAmount(getFormattedAmount(amountInCents));
                            }
                        }, disabled: loading }))),
                simpleMode ? (React.createElement(Button, { loading: loading, disabled: buttonDisabled, tertiary: true, wide: true, type: "submit" }, t("payment_portal:payment.pay"))) : (React.createElement(IdealButton, { loading: loading, variant: "transparent", disabled: buttonDisabled, type: "submit" }, t("payment_portal:payment.pay_with_ideal"))),
                React.createElement(StyledFrameFooter, { appTheme: getAppThemeName() },
                    getDossierLink(appTheme),
                    React.createElement(LanguageSelection, { onlyShowOnMobile: true },
                        React.createElement(LanguageToggle, { onClick: (event) => {
                                setExpanded(prevToggle => !prevToggle);
                                event.preventDefault();
                            } }),
                        React.createElement(LanguageSelector, { isExpanded: isExpanded, isReversed: true }))))),
        getContactLink(appTheme)));
};
export default PaymentFrame;
